import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Models
import EducationEntry from '../../../../../../models/v2/education_entry';

// Base
import Col from '../../../../base/col';
import Row from '../../../../base/row';

// Related Components
import Listing from './education_entries/listing';
import Loading from './education_entries/loading';

export default class EducationEntries extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    persona: PropTypes.object.isRequired,
  }

  state = {
    loading: true,
    educationEntries: [],
  }

  componentDidMount() {
    const { profile, persona } = this.props;
    let url = `/api/v2/profiles/${profile.id}/education_entries`;
    if (!isEmptyObject(persona)) {
      url = `/api/v2/personas/${persona.id}/education_entries`;
    }
    EducationEntry
      .url(url)
      .sort('start_year DESC, start_month DESC')
      .all(false)
      .then((educationEntries) => {
        this.setState({
          educationEntries,
          loading: false,
        })
    })
  }

  render() {
    const { persona } = this.props;
    const { loading, educationEntries } = this.state;

    if (loading) {
      return <Loading />
    }

    return (
      <Row className='margin-top-15 margin-bottom-10' nested>
        <Col s={12} className='med-font dark margin-bottom-10'>
          Education
        </Col>
        {
          educationEntries.map((educationEntry) => (
            <Col s={12} key={educationEntry.id}>
              <Listing {...{
                persona,
                educationEntry,
                educationEntries,
              }} />
            </Col>
          ))
        }
      </Row>
    )
  }
}